import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import UserEditService from 'app/admin/user/service/UserEditService';
import EditFormRegistrationStatusField from 'modules/ui/editform/fields/EditFormRegistrationStatusField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { useParams, withRouter } from 'react-router';
import EditFormCheckboxField from 'modules/ui/editform/fields/EditFormCheckboxField';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';
import UserGroupEditService from 'app/admin/userGroup/service/UserGroupEditService';

const config = data => {
	return {
		key: 'userEditForm',
		text: 'Hozzáférés',
		topic: 'user',
		service: UserEditService,
		defaultValue: () => UserGroupEditService.create(),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					text: 'Név',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'roles',
					text: 'Szerepkör',
					component: EditFormSelectField,
					multiple: true,
					type: 'enum',
					required: true,
					items: () => UserEditService.getRoleListSelection()
				},
				{
					key: 'userGroups',
					text: 'Felhasználó csoport',
					component: EditFormSelectField,
					multiple: true,
					required: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'registrationStatus',
					text: 'Aktív',
					component: EditFormRegistrationStatusField
				},
				{
					key: 'password',
					text: 'Jelszó',
					component: EditFormTextField,
					required: true,
					type: 'password',
					autoComplete: 'new-password'
				},
				{
					key: 'passwordAgain',
					text: 'Jelszó mégegyszer',
					component: EditFormTextField,
					required: true,
					type: 'password',
					autoComplete: 'new-password'
				},
				{
					key: 'email',
					text: 'E-mail',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'enabled',
					text: 'Engedélyezve',
					component: EditFormCheckboxField
				}
			];

			return fields;
		}
	};
};

function UserEditForm() {
	const { id, tabKey } = useParams();

	const myConfig = config({ id });
	return <EditFormPage config={myConfig} startTabValue={tabKey} />;
}

export default withRouter(UserEditForm);